import { useMemo } from 'react';
import { AdvisorProfileView } from '@/shared/components/advisor-profile';
import type { AdminAdvisorEditorDetail } from '../../types/admin-advisor.type';
import type { AdvisorEditorFormData } from './advisorEditor.types';
import { UnsavedChangesBanner } from '../provider-editor/UnsavedChangesBanner';
import { advisorFormToPreviewProfile } from './utils/advisorEditorTransformers';

type AdvisorPreviewTabProps = {
  advisor: AdminAdvisorEditorDetail;
  formData: AdvisorEditorFormData;
  isDirty: boolean;
};

export const AdvisorPreviewTab = ({
  advisor,
  formData,
  isDirty,
}: AdvisorPreviewTabProps) => {
  const profile = useMemo(
    () => advisorFormToPreviewProfile(advisor, formData),
    [advisor, formData],
  );

  return (
    <div role="tabpanel" className="space-y-4">
      {isDirty && <UnsavedChangesBanner />}
      <AdvisorProfileView profile={profile} showServiceProviderActions={false} />
    </div>
  );
};
